import { Question } from "@phosphor-icons/react";
import { useTranslation } from "@/contexts/LanguageContext";

const COPY = {
  en: {
    eyebrow: "FAQ",
    q: "Does this site support mirrorless and film cameras?",
    a: [
      "Yes. Everything here — aperture, shutter speed, ISO, metering, white balance, composition and lighting — works the same on DSLR, mirrorless and film cameras.",
      "The settings calculator includes 75+ DSLR and mirrorless bodies (Canon R, Nikon Z, Sony A7/A6000, Fujifilm X and more) plus classic film cameras like the Canon AE-1 Program. Use the DSLR / Mirrorless / Film buttons to find yours.",
      "Where mirrorless cameras work differently (electronic viewfinder, autofocus, silent shutter, sensor care), lessons include a short \"On mirrorless\" note. Film shooters get a full Film Photography lesson, a Sunny-16 meter and a reciprocity calculator.",
    ],
  },
  es: {
    eyebrow: "PREGUNTAS FRECUENTES",
    q: "¿Este sitio sirve para cámaras mirrorless y de película?",
    a: [
      "Sí. Todo lo que aprendes aquí — apertura, velocidad de obturación, ISO, medición, balance de blancos, composición e iluminación — funciona igual en cámaras DSLR, mirrorless y de película.",
      "La calculadora de ajustes incluye más de 75 cuerpos DSLR y mirrorless (Canon R, Nikon Z, Sony A7/A6000, Fujifilm X y más) además de cámaras de película clásicas como la Canon AE-1 Program. Usa los botones DSLR / Mirrorless / Película para encontrar la tuya.",
      "Donde las mirrorless funcionan distinto (visor electrónico, autoenfoque, obturador silencioso, cuidado del sensor), las lecciones incluyen una nota corta \"En mirrorless\". Quienes usan película tienen una lección completa de Fotografía con Película, un fotómetro Sunny-16 y una calculadora de reciprocidad.",
    ],
  },
};

export const CameraTypesFaq = () => {
  const { lang } = useTranslation();
  const c = COPY[lang] || COPY.en;
  return (
    <div className="bg-[#121214]/80 border border-white/10 rounded-2xl p-6 sm:p-8" data-testid="camera-types-faq">
      <p className="text-[#F5A524] text-xs uppercase tracking-[0.25em] font-semibold mb-3">{c.eyebrow}</p>
      <h2 className="font-['Outfit'] text-xl sm:text-2xl font-semibold text-white tracking-tight mb-4 flex items-start gap-3">
        <Question weight="fill" className="w-6 h-6 text-[#F5A524] shrink-0 mt-1" />
        <span data-testid="camera-types-faq-question">{c.q}</span>
      </h2>
      <div className="space-y-3 text-[#A1A1AA] text-sm sm:text-base leading-relaxed" data-testid="camera-types-faq-answer">
        {c.a.map((p, i) => <p key={i}>{p}</p>)}
      </div>
    </div>
  );
};
